import bluePattern from './assets/home/bluePattern.svg';
import greenPattern from './assets/home/greenPattern.svg';
import pinkPattern from './assets/home/pinkPattern.svg';
import purplePattern from './assets/home/purplePattern.svg';
import bluePlay from './assets/home/bluePlayButton.svg';
import greenPlay from './assets/home/greenPlayButton.svg';
import pinkPlay from './assets/home/pinkPlayButton.svg';
import purplePlay from './assets/home/purplePlayButton.svg';
import activityPattern from './/assets/exercises/background.svg';

export const activity_miniatures_palettes = {
    purple: {
        pbcolor1: '#9D29CF',
        pbcolor2: '#C160EB',
        pbcolor3: '#D596F1',
        textcolor: '#C160EC',
        pattern: purplePattern,
        playbutton: purplePlay
    },
    blue: {
        pbcolor1: '#017DDC',
        pbcolor2: '#1197FF',
        pbcolor3: '#71C1FF',
        textcolor: '#1197FF',
        pattern: bluePattern,
        playbutton: bluePlay
    },
    pink: {
        pbcolor1: '#D43991',
        pbcolor2: '#EB83BE',
        pbcolor3: '#F2C6DF',
        textcolor: '#EC83BE',
        pattern: pinkPattern,
        playbutton: pinkPlay
    },
    green: {
        pbcolor1: '#218668',
        pbcolor2: '#23C394',
        pbcolor3: '#7DE5C6',
        textcolor: '#23C394',
        pattern: greenPattern,
        playbutton: greenPlay
    },
};

export const activity_palettes = {
    //TODO: colori di viola, blu e rosa da aggiustare, ho fatto solo il verde
    purple: {
        primary: '#9D29CF',
        secondary: '#C160EB',
        background: activityPattern
    },
    blue: {
        primary: '#017DDC',
        secondary: '#1197FF',
        background: activityPattern
    },
    pink: {
        primary: '#F2C6DF',
        secondary: '#E8378A',
        blue: '#3082FF',
        background: activityPattern
    },
    green: {
        primary: '#7DE5C6',
        secondary: '#3E9883',
        tertiary: '#B8E6BF',
        error_background: '#FF91AA',
        error_text: '#8A1516',
        background: activityPattern
    },
};


